import { render } from "./AdminJourneyPage.vue?vue&type=template&id=e338ecb2"
import script from "./AdminJourneyPage.vue?vue&type=script&lang=js"
export * from "./AdminJourneyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__